import _get from "lodash/get";
import { AnyAction } from "redux";
import { PaymentState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): PaymentState => ({
    methods: [],
    paymentSuccessRedirectUrl: "",
    paymentSuccessRedirectAction: null,
});

const reducer = (state = initialState(), action: AnyAction) => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_PAYMENT):
            return {
                ...state,
                paymentSuccessRedirectUrl: action.payload.url,
                paymentSuccessRedirectAction: action.payload.action,
                isLeaseError: action.payload.isLeaseError,
                leaseErrorCartItemId: action.payload.leaseErrorCartItemId,
                showDelayOnPurchaseModal: action.payload.showDelayOnPurchaseModal,
            };
        case fulfilled(AT.CHECKOUT_SET_SELECTED_PAYMENT_TYPE):
            return {
                ...state,
                selected: {
                    type: action.payload.paymentType,
                },
            };
        case fulfilled(AT.CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS):
            return {
                ...state,
                methods: _get(action, "payload.payment.methods", []),
                selected: {
                    type: _get(action, "payload.payment.selected.type", null),
                },
            };
        case AT.CHECKOUT_RESET_LEASE_ERROR:
            return {
                ...state,
                isLeaseError: false,
                leaseErrorCartItemId: undefined,
            };
        case AT.CHECKOUT_CLOSE_DELAY_ON_PURCHASE_MODAL:
            return {
                ...state,
                showDelayOnPurchaseModal: false,
            };
        default:
            return state;
    }
};

export default reducer;
